import { render, staticRenderFns } from "./Fund-Features.vue?vue&type=template&id=a773548a&scoped=true&"
import script from "./Fund-Features.vue?vue&type=script&lang=js&"
export * from "./Fund-Features.vue?vue&type=script&lang=js&"
import style0 from "./Fund-Features.vue?vue&type=style&index=0&id=a773548a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a773548a",
  null
  
)

export default component.exports